import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomerLanguageDto } from 'src/core/models/virtual-translator/customer-language.dto';

@Injectable({
  providedIn: 'root',
})
export class CustomerLanguageService {
  private apiBase = environment.apis.default.url;

  constructor(private http: HttpClient) {}

  getCustomerLanguages(): Observable<CustomerLanguageDto[]> {
    return this.http.get<CustomerLanguageDto[]>(
      `${this.apiBase}/api/app/virtual-translator/customer-languages`,
    );
  }
}
